import { useContext, createContext } from "react";

export const CoveoRecommendationEngineContext = createContext(null);

export function useCoveoRecommendationEngine() {
  return useContext(CoveoRecommendationEngineContext);
}
